import React, { useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";

import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ImageIcon from "@mui/icons-material/Image";
import InsightsIcon from "@mui/icons-material/Insights";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PublicIcon from "@mui/icons-material/Public";
import { TravelExplore } from "@mui/icons-material";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const OliveProjectComp = () => {
  useEffect(() => {
    localStorage.removeItem("projectId");
  }, []);
  const ProjectCards = [
    {
      icon: <AgricultureIcon fontSize="large" />,
      projectName:
        "Pilot Project on Direct Seeding of Rice (DSR) with Improved Water & Pest Management",
      // url: "/project/dashboard/54e529f7-f7e8-41a9-9f77-edb88fec7ea1",
      // url:"/project/dashboard/farmers-group/FPO/d986ef06-1cb6-4615-b853-e6874e40cd71",
      url: "project/dashboard/d986ef06-1cb6-4615-b853-e6874e40cd71",
      color: "#27AE60",
    },
    {
      icon: <LocalGroceryStoreIcon fontSize="large" />,
      projectName:
        "Pilot Project on Promotion of Vegetable Cluster and Development of a Sustainable Supply Chain to Boost Farmers Net Income",
      // url: "/project/dashboard/43bd693a-8890-4531-8e74-0f443893d70a",
      // url:"/project/dashboard/farmers-group/FPO/c31e207c-2474-4dbf-9230-4c33fc7c433e",
      url: "/project/dashboard/c31e207c-2474-4dbf-9230-4c33fc7c433e",
      color: "#E4D00A",
    },
  ];

  return (
    <Box sx={{ background: "", minHeight: "100vh" }}>
      <div className="container-fluid p-5">
        <Grid container spacing={4}>
          {ProjectCards.map((item, i) => {
            const isExternal = item.url.startsWith("http");

            return (
              <Grid item xs={12} sm={6} md={4} lg={6} key={i}>
                <Card
                  sx={{
                    p: 3,
                    borderRadius: 2,
                    height: "100%",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    transition: "0.3s",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",

                    borderTop: `3px solid ${item.color}`,
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: "center" }}>
                    {React.cloneElement(item.icon, {
                      sx: { color: item.color },
                    })}

                    <Typography
                      variant="subtitle1"
                      sx={{ mt: 1.5, fontWeight: 600, minHeight: "48px" }}
                    >
                      {item.projectName}
                    </Typography>
                  </CardContent>

                  <div className="d-flex justify-content-center">
                    <Col lg="8">
                      {item.projectName ===
                      "Pilot Project on Direct Seeding of Rice (DSR) with Improved Water & Pest Management" ? (
                        <Link
                          to={`/project/dashboard/d986ef06-1cb6-4615-b853-e6874e40cd71`}
                        >
                          <Button
                            size="sm"
                            variant="outlined"
                            fullWidth
                            sx={{
                              textTransform: "none",
                              borderRadius: 1,
                              marginBottom: 1,
                              fontWeight: 600,
                              color: item.color,
                              borderColor: item.color,

                              "&:hover": {
                                backgroundColor: item.color,
                                borderColor: item.color,
                                color: "white",
                              },
                            }}
                            onClick={() => {
                              localStorage.setItem(
                                "projectId",
                                "d986ef06-1cb6-4615-b853-e6874e40cd71"
                              );
                            }}
                          >
                            View
                          </Button>
                        </Link>
                      ) : (
                        <Link
                          to={`/project/dashboard/c31e207c-2474-4dbf-9230-4c33fc7c433e`}
                        >
                          <Button
                            size="sm"
                            variant="outlined"
                            fullWidth
                            sx={{
                              textTransform: "none",
                              borderRadius: 1,
                              marginBottom: 1,
                              fontWeight: 600,
                              color: item.color,
                              borderColor: item.color,

                              "&:hover": {
                                backgroundColor: item.color,
                                borderColor: item.color,
                                color: "white",
                              },
                            }}
                            onClick={() => {
                              localStorage.setItem(
                                "projectId",
                                "c31e207c-2474-4dbf-9230-4c33fc7c433e"
                              );
                            }}
                          >
                            View
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </div>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Box>
  );
};

export default OliveProjectComp;
